// Util
import { DateUtil } from '@/utils/dateutil';

import axios from 'axios';
import config from '@/config/env-constants';

export default {

    getTransferCompanyRequests(filterBy, view, currUserId) {
        let url = `${config.cloudFunctionsBaseUrl}/getTransferCompanyRequests`;
        return axios.post(url, {
            view: view,
            currUserId: currUserId,
            filterBy: JSON.stringify(filterBy)
        });
    },

    confirmTransferCompanyRequests(transferRequests, currUserId) {
        let url = `${config.cloudFunctionsBaseUrl}/confirmTransferCompanyRequests`;
        return axios.post(url, {
            currUserId: currUserId,
            currTimeStamp: DateUtil.getCurrentTimestamp(),
            transferRequests: JSON.stringify(transferRequests)
        });
    },
}